import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function VendorLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/vendor/login', { email, password });
      const token = res.data.token;
      const vendor = res.data.vendor;
      vendor.role = 'vendor';
      localStorage.setItem('ts_token', token);
      localStorage.setItem('ts_user', JSON.stringify(vendor));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      navigate('/vendor/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1 style={{ color: 'var(--primary)' }}>TradeSync</h1>
          <p>Vendor Portal</p>
          <p style={{ fontSize: '0.75rem', color: 'var(--gray-400)', marginTop: '0.5rem' }}>
            Shandong Sincerity Crafts & Partners
          </p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" required autoComplete="email" />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" required autoComplete="current-password" />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Access Orders'}
          </button>
        </form>
      </div>
    </div>
  );
}
